import React from 'react'
import ButtonAdd from '../Includes/Button/ButtonAdd'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  isDifferent
} from '../../Functions/Compare'
import {
  get_id
} from '../../Functions/Functions'
import {
  get_ouverture,
  get_ouverture_semaine
} from '../../Functions/Ouverture'
import {
  initial
} from '../../Variables/Variables'
import {
  SET_SEMAINE_WORKING,
  EDIT_CURRENT_SEMAINE
} from '../../Redux/Actions/Semaines'

const SemainesToolbarContent = () => {
  const dispatch = useDispatch()
  const ouverture = useSelector(state => state.ouverture.ouverture)
  const Semaine = (empty) => {
    if (empty) {
      dispatch(EDIT_CURRENT_SEMAINE(initial.empty.creneaux))
    } else {
      dispatch(EDIT_CURRENT_SEMAINE(
        (isDifferent([ouverture], [get_ouverture()]))
          ? get_ouverture_semaine(ouverture)
          : initial.semaine.creneaux.map(item => {
              return {
                ...item,
                id: get_id()
              }
            })
      ))
    }
    dispatch(SET_SEMAINE_WORKING({
      id: '',
      nom: '',
      new: true,
      open: true,
      edit: false,
      read: false
    }))
  }
  return (
    <>
      <ButtonAdd
        data-testid="semaines-ajouter-pre-remplie"
        post={true}
        mobile="Pré-remplie"
        title="Semaine pré-remplie"
        onClick={() => Semaine(false)}
      />
      <ButtonAdd
        data-testid="semaines-ajouter-vierge"
        mobile="Vide"
        title="Semaine vierge"
        onClick={() => Semaine(true)}
      />
    </>
  )
}

export default SemainesToolbarContent
